module.exports = __webpack_public_path__ + "static/img/icon_forth.685ba73a.png";